









ENV = require "config/env"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["post", "isNew"]
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		pageName: -> return this.$route.name
		projectName: -> 
			if this.$route.params.projectName? then return this.$route.params.projectName
			if this.post.projects?.length > 1 then return "all"
			if this.post.projects?.length > 0
				switch this.post.projects[0]
					when 9 then return "project01"
					when 10 then return "project02"
					when 11 then return "project03"
					when 12 then return "supervision"
			return "all"
		category: -> return if this.$route.params.category? then this.$route.params.category else ""
		date: -> WP.date(this.post)
		excerpt: -> WP.excerpt(this.post)
		styledTitleJa: ->
			if this.post.acf.titleHTML? then return this.post.acf.titleHTML.replace(/&lt;/g, '<') .replace(/&gt;/g, '>') .replace(/&quot;/g, '"') .replace(/&#039;/g, '\'') .replace(/&#044;/g, ',') .replace(/&amp;/g, '&')
		styledTitleEn: ->
			if this.post.acf.EnTitleHTML? then return this.post.acf.EnTitleHTML.replace(/&lt;/g, '<') .replace(/&gt;/g, '>') .replace(/&quot;/g, '"') .replace(/&#039;/g, '\'') .replace(/&#044;/g, ',') .replace(/&amp;/g, '&')
		titleStyle: ->
			if this.post.acf.titleStyle?
				try
					return JSON.parse(this.post.acf.titleStyle.replace(/&lt;/g, '<') .replace(/&gt;/g, '>') .replace(/&quot;/g, '"') .replace(/&#039;/g, '\'') .replace(/&#044;/g, ',') .replace(/&amp;/g, '&'))
				catch
					return null
			return null
		# isNew: -> WP.isNew(this.post)
		# projectName: ->
		# 	for category in ENV.categories
		# 		if WP.hasCategory(this.post, category.id) then return category.slug
		to: ->
			if this.isEnglish then return {name: "en_post", params: {id: this.post.id, projectName: this.projectName}}
			return {name: "post", params: {id: this.post.id, projectName: this.projectName}}
	methods:
		renderText: (ja, en) -> return if !this.isEnglish then ja else en
		hasCategory: (post) -> WP.hasCategory(post, categoryID)
		hasSupervision: (post) ->
			for project in post.projects
				if project is 12 then return true
			return false
		categoryClasses: (post) ->
			classes = []
			if this.projectName is "all"
				if post.projects?.length > 0
					if this.hasSupervision(post) then classes.push "supervision"
					else
						switch post.projects[0]
							when 9 then classes.push "project01"
							when 10 then classes.push "project02"
							when 11 then classes.push "project03"
							when 12 then return "supervision"
			else
				classes.push this.projectName
			for category in post.categories
				# if this.pageName.replace("en_") is "posts"
				# 	if 5<= category and category <= 7 then continue
				classes.push WP.getCategorySlug(category)
			return classes




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/posts/postLink.vue